module.exports = __webpack_public_path__ + "zvetseni-prsou_5_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_5_before.jpg
// module id = 1356
// module chunks = 0